import NoDataToDisplay from "../../../charts/utils/NoData";
import { palette } from "../../../assets/theme/theme";
import { useContext, useState } from "react";
import CustomButtonSimple from "../../../components/CustomMiscellaneous/CustomButtonSimple";
import { useEffect } from "react";
import CircleIcon from '@mui/icons-material/Circle';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { formatDateWithHours } from "../../../utils/DateUtils";
import { ExpedicoesConfig } from "./Expedicoes.config";
import QRCodeGenerator from "../../../components/QRCodes/QRCodeGenerator";
import { toast } from 'react-hot-toast';
import { genericGet, genericPost } from "../../../services/api.service";
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import FotoDisplay from "./FotoDisplay";
import useForm from "../../../form/hooks/useForm";
import Form from "../../../form";
import { getColorByEstadoOperacao, getEstadoOperacao } from "../../FactoryFloor/utils";
import { FactoryFloorContext } from "../../../contexts/FactoryFloorContext";


const toastDuration = 3000;


export function Expedicoes({ pecas, setPecas }: any) {

    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const [expedicaoGeral, setExpedicaoGeral] = useState(false);

    const [expeditionOpenIndex, setExpeditionOpenIndex] = useState<number | null>(null);

    const [pecasToDisplay, setPecasToDisplay] = useState([]);

    const {selectionValues} = useContext(FactoryFloorContext);


    const form = useForm({ formConfigs: ExpedicoesConfig });




    useEffect(() => {
        form.init()
    }, [openIndex])


    const submitExpedicao = async (pecaId: string) => {

        await toast.promise(
            (async () => {
                await genericPost(`/pecas/${pecaId}/expedicao`)(form.state);

                const updatedPecas = await genericGet(`/obras/${selectionValues.obra?.id}/entregas/${selectionValues.entrega?.id}/operacoes/Expedição`)
                console.log("Setting pecas as: ", updatedPecas);
                setPecas(updatedPecas);
                setOpenIndex(null);
            })()
            ,
            {
                success: (t: any) => (
                    <span>
                        <span>Expedição criada com sucesso!!</span>
                    </span>
                ),
                error: ({ response }: any) => (
                    <span>
                        <span>Erro ao criar entidade Expedição <p>{response.data.error}</p></span>
                    </span>
                ),
                duration: toastDuration
            } as any
        )
    }


    const submitExpedicaoGeral = async () => {

        await toast.promise(
            (async () => {
     
                await genericPost(`/obras/${selectionValues.obra?.id}/expedicao/all`)(form.state);
                const updatedPecas = await genericGet(`/obras/${selectionValues.obra?.id}/operacoes/Expedição`)
                setPecas(updatedPecas);
                setOpenIndex(null);
                setExpedicaoGeral(false);
            })()
            ,
            {
                success: (t: any) => (
                    <span>
                        <span>Expedição Geral criada com sucesso!!</span>
                    </span>
                ),
                error: ({ response }: any) => (
                    <span>
                        <span>Erro ao criar entidade Expedição <p>{response.data.error}</p></span>
                    </span>
                ),
                duration: toastDuration
            } as any
        )
    }



    const getDatasOperacao = (peca: any) => {
        return { start: formatDateWithHours(peca.inicioExpedicao), end: formatDateWithHours(peca.fimExpedicao) }
    }

    const todasPecasConcluidas = () => {
        const pecasNaoConcluidas = pecasToDisplay.filter(p => getEstadoOperacao(p,'') != 'Concluído');
        return pecasNaoConcluidas.length == 0;
    }

    useEffect(() => {
        setPecasToDisplay(pecas);
    }, [pecas])


    return (<div>
        {pecasToDisplay?.length ? <div>
            {!todasPecasConcluidas() ?
                <div style={{ width: '20%', margin: 40 }}>
                    <CustomButtonSimple
                        text={"Expedir todas"}
                        color={palette.green}
                        onClick={() => setExpedicaoGeral(true)}
                        Icon={<DoneAllIcon/>}
                    />
                    {expedicaoGeral ? <Form
                        onCancel={() => setExpedicaoGeral(false)}
                        submitData={() => submitExpedicaoGeral()}
                        idProp={"reference"}
                        entityName={"Expedição Geral"}
                        isNewEntity buildGetterFunction={() => null}
                        tableConfigs={ExpedicoesConfig.filter((e: any) => e.id != 'quantidade')}
                        form={form} /> : null}
                </div>
                : null
            }


            {pecasToDisplay.map((p: any, idx: number) => {
                return (<div>

                    <div key={idx} style={{ margin: 50, borderStyle: 'solid', borderWidth: '1px', borderRadius: '5px', padding: 20, paddingBottom: 50, borderColor: palette.gray.medium, transition: '0.6s max-height', maxHeight: 'auto' }}>
                        <div style={{ float: 'right' }}>
                            {/* {idx == openIndex ? <ArrowDropUp style={{ cursor: 'pointer' }} onClick={() => setOpenIndex(null)} /> : <ArrowDropDownIcon style={{ cursor: 'pointer' }} onClick={() => setOpenIndex(idx)} />} */}
                        </div>
                        <div style={{ display: 'flex', justifyItems: 'space-between', marginTop: 20 }}>
                            <div style={{ width: '100%', marginLeft: 40 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h1>{p.peca.reference}</h1>
                                    <div>
                                        <div style={{ fontSize: '1.4em', marginRight: 40, display: 'flex', alignItems: 'center' }}>
                                            <div>
                                                Estado: <span style={{ fontWeight: 'bold' }}>{getEstadoOperacao(p,'')}</span>

                                            </div>
                                            <CircleIcon style={{ color: getColorByEstadoOperacao(getEstadoOperacao(p,'')), marginLeft: 10 }} />
                                        </div>
                                        <p>Iniciado a: {getDatasOperacao(p).start}</p>
                                        <p>Terminado a: {getDatasOperacao(p).end}</p>
                                    </div>
                                </div>
                                <p>Quantidade para entrega: {p.quantidade}</p>
                                <p>Total expedido: {p.expedicoes.reduce((prev: number, curr: any) => prev + curr.quantidade, 0)}</p>
                                {getEstadoOperacao(p,'') != 'Concluído' ?
                                    <div style={{ width: '20%', marginTop: 20 }}>
                                        <CustomButtonSimple
                                            text={`Nova expedição para ${p.peca.reference}`}
                                            color={palette.orange}
                                            onClick={() => setOpenIndex(idx)}
                                        />
                                    </div> : null
                                }

                                <div style={{ marginTop: 30 }}>
                                    <h2>Expedições</h2>
                                    {p.expedicoes.map((e: any, exp_idx: number) => {
                                        return (
                                            <div style={{ borderColor: palette.gray.medium, borderRadius: 5, borderWidth: '1px', borderStyle: 'solid', padding: 20, marginBottom: 20 }}>
                                                {/* <HorizontalRule /> */}
                                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
                                                    <div style={{ width: '70%' }}>
                                                        <p style={{ fontSize: '1.2em', fontWeight: 'bold' }}>Expedição {e.id}</p>
                                                        <p>Quantidade expedida: {e.quantidade}</p>
                                                        <p>Observações: {e.observacoes}</p>
                                                        <p>Guia: {e.guia}</p>
                                                    </div>
                                                    {exp_idx == expeditionOpenIndex ? <QRCodeGenerator value={`expedicao-${p.peca.id}-${e.id}`} /> : <QrCodeScannerIcon onClick={() => setExpeditionOpenIndex(exp_idx)} style={{ cursor: 'pointer', margin: 30 }} />}
                                                </div>
                                                <div style={{ borderStyle: 'solid', borderColor: palette.gray.light, borderWidth: '1px', borderRadius: 5, padding: 20, backgroundColor: palette.gray.light }}>
                                                    <p style={{ fontSize: '1.2em', fontWeight: 'bold' }}>Documentação</p>

                                                    {e.fotos.length > 0 ? <FotoDisplay pecaId={p.id} expedicaoId={e.id} fotos={e.fotos} /> : <div>Nenhuma documentação associada à expedição</div>}
                                                </div>
                                            </div>)

                                    })}
                                </div>

                                {openIndex === idx ? <Form onCancel={() => setOpenIndex(null)}
                                    submitData={() => submitExpedicao(p.id)}
                                    idProp={"reference"}
                                    entityName={"Expedição"}
                                    isNewEntity buildGetterFunction={() => null}
                                    tableConfigs={ExpedicoesConfig}
                                    form={form} /> : null}
                            </div>
                        </div>

                    </div>

                </div>)
            })}
        </div> : <NoDataToDisplay />}


    </div>)






}